const SAFE_URL_PATTERN = /^(https?:|mailto:|tel:|\/|#)/i;
const DATA_IMAGE_PATTERN = /^data:image\/(png|gif|jpe?g|webp);base64,/i;

const BLOCKED_TAGS = new Set([
    'script',
    'style',
    'iframe',
    'object',
    'embed',
    'link',
    'meta',
    'base',
    'form',
    'input',
    'button',
    'textarea',
    'select',
    'option',
]);

const URI_ATTRIBUTES = new Set(['href', 'src', 'xlink:href', 'action', 'formaction']);

const SAFE_ATTRIBUTES = new Set([
    'alt',
    'aria-label',
    'aria-labelledby',
    'class',
    'colspan',
    'height',
    'id',
    'rel',
    'rowspan',
    'scope',
    'target',
    'title',
    'width',
]);

const isSafeUrl = (value) => {
    const normalizedValue = String(value ?? '').trim();
    return SAFE_URL_PATTERN.test(normalizedValue) || DATA_IMAGE_PATTERN.test(normalizedValue);
};

const sanitizeNode = (node) => {
    [...node.children].forEach((child) => {
        const tagName = child.tagName.toLowerCase();

        if (BLOCKED_TAGS.has(tagName)) {
            child.remove();
            return;
        }

        [...child.attributes].forEach((attribute) => {
            const attributeName = attribute.name.toLowerCase();

            if (attributeName.startsWith('on')) {
                child.removeAttribute(attribute.name);
                return;
            }

            if (URI_ATTRIBUTES.has(attributeName)) {
                if (!isSafeUrl(attribute.value)) {
                    child.removeAttribute(attribute.name);
                }
                return;
            }

            if (!SAFE_ATTRIBUTES.has(attributeName)) {
                child.removeAttribute(attribute.name);
            }
        });

        if (tagName === 'a' && child.getAttribute('target') === '_blank') {
            child.setAttribute('rel', 'noopener noreferrer');
        }

        sanitizeNode(child);
    });
};

export const sanitizeHtml = (html) => {
    if (!html || typeof window === 'undefined' || typeof DOMParser === 'undefined') {
        return '';
    }

    const document = new DOMParser().parseFromString(String(html), 'text/html');
    sanitizeNode(document.body);
    return document.body.innerHTML;
};
